import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const USER_ONBOARDING_ENABLE = gql(`
  mutation userOnboardingEnable {
    userOnboardingEnable {
      __typename
      id
      preferences {
        __typename
        onboardingDisabled
      }
    }
  }
`);

export function useUserOnboardingEnable() {
  return useMutation(USER_ONBOARDING_ENABLE);
}
